import {PersonService} from "@/common/api/person.service";
import {PERSON_GET, PERSONS_GET, PERSON_CREATE, PERSON_UPDATE, PERSON_SEARCH, PERSON_SEARCH_NAME} from "./actions/person.type";
import {CHANGE_PROGRESS} from "./mutations/mutations.type"
import {
    SET_PERSON,
    SET_PERSONS,
    SET_PERSON_PAGINATION,
    PERSON_RESET_STATE, SET_PERSONS_SIMPLE
} from "./mutations/person.type";

const initialState = () => {
    return {
        person: {
            name: "",
            cpf: "",
            phone: "",
            birthdate: ""
        },
        
        personPagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },
        personsSimple: [],
        
        persons: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },

    };
};

export const state = initialState();

const getters = {
    person: state => {
        return state.person;
    },
    persons: state => {
        return state.persons
    },
    personsSimple: state => {
        return state.personsSimple
    },
    personPagination: state => {
        return state.personPagination
    }
};

const mutations = {
    [SET_PERSON](state, data) {
        state.person = data;
    },
    [SET_PERSONS](state, data) {
        state.persons = data;
    },
    [SET_PERSONS_SIMPLE](state, data) {
        state.personsSimple = data;
    },
    [SET_PERSON_PAGINATION](state, data) {
        state.persons.activePage = data.page
        state.personPagination.itemsPerPage = data.itemsPerPage
        state.personPagination.orderBy = data.orderBy
        state.personPagination.sortDesc = data.sortDesc
    },
    [PERSON_RESET_STATE](state) {
        Object.assign(state, initialState());
    }
};

const actions = {
    async [PERSON_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await PersonService.get(id);
        commit(SET_PERSON, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PERSONS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await PersonService.list();
        commit(SET_PERSONS, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PERSON_CREATE]({state}) {
        let person = state.person
        if (person.cpf === ""){
            person.cpf = null
        }
        if (person.birthdate === ""){
            person.birthdate = null
        }

        return PersonService.post("", state.person);
    },
    async [PERSON_SEARCH]({commit}) {
        // commit(CHANGE_PROGRESS, true)
        const {data} = await PersonService.search(
            state.persons.activePage,
            state.personPagination.itemsPerPage,
            state.persons.active,
            state.personPagination.search,
            state.personPagination.orderBy,
            state.personPagination.sortDesc)
        commit(SET_PERSONS, data)
        // commit(CHANGE_PROGRESS, false)
    },
    async [PERSON_SEARCH_NAME]({commit},name) {    
        commit(CHANGE_PROGRESS, true);
        const {data} = await PersonService.searchByName(name);
        commit(SET_PERSONS_SIMPLE, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PERSON_UPDATE]({state}) {
        let person = state.person
        if (person.cpf === ""){
            person.cpf = null
        }
        if (person.birthdate === ""){
            person.birthdate = null
        }

        return PersonService.update("", state.person);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
